$(document).ready(function() {
    const $activeCategory = $('.section-blog-list .taxonomy-name.active');

    if ($activeCategory.length) {
        const $scrollContainer = $('.section-blog-list .wrap-scroll');
        const activeOffsetLeft = $activeCategory[0].offsetLeft; // Distance from the left of the container
        const activeWidth = $activeCategory.outerWidth(); // Width of the active category element
        const containerWidth = $scrollContainer.width(); // Width of the scroll container

        // Calculate the scroll position to ensure the active item is fully visible
        const scrollPosition = activeOffsetLeft - (containerWidth / 2) + (activeWidth / 2);

        // Set the scroll position of the container
        $scrollContainer.scrollLeft(scrollPosition);
    }
});
